// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3VGhT","overflowing":"ReadFullNote_overflowing__1eI92"};